/* tslint:disable */
/* eslint-disable */
/**
 * Pfa API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  Starter,
  StarterDto,
  StarterResponse,
} from '../models/index';
import {
    StarterFromJSON,
    StarterToJSON,
    StarterDtoFromJSON,
    StarterDtoToJSON,
    StarterResponseFromJSON,
    StarterResponseToJSON,
} from '../models/index';

export interface ApiStartersPostRequest {
    starterDto?: StarterDto;
}

export interface ApiStartersShowShowIdBookerBookerIdGetRequest {
    showId: number;
    bookerId: string;
}

export interface ApiStartersValidatePostRequest {
    starterDto?: StarterDto;
}

/**
 * 
 */
export class StartersApi extends runtime.BaseAPI {

    /**
     */
    async apiStartersPostRaw(requestParameters: ApiStartersPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Starter>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-KEY"] = await this.configuration.apiKey("X-API-KEY"); // ApiKey authentication
        }

        const response = await this.request({
            path: `/api/Starters`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: StarterDtoToJSON(requestParameters['starterDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StarterFromJSON(jsonValue));
    }

    /**
     */
    async apiStartersPost(requestParameters: ApiStartersPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Starter> {
        const response = await this.apiStartersPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiStartersShowShowIdBookerBookerIdGetRaw(requestParameters: ApiStartersShowShowIdBookerBookerIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<StarterResponse>>> {
        if (requestParameters['showId'] == null) {
            throw new runtime.RequiredError(
                'showId',
                'Required parameter "showId" was null or undefined when calling apiStartersShowShowIdBookerBookerIdGet().'
            );
        }

        if (requestParameters['bookerId'] == null) {
            throw new runtime.RequiredError(
                'bookerId',
                'Required parameter "bookerId" was null or undefined when calling apiStartersShowShowIdBookerBookerIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-KEY"] = await this.configuration.apiKey("X-API-KEY"); // ApiKey authentication
        }

        const response = await this.request({
            path: `/api/Starters/show/{showId}/booker/{BookerId}`.replace(`{${"showId"}}`, encodeURIComponent(String(requestParameters['showId']))).replace(`{${"BookerId"}}`, encodeURIComponent(String(requestParameters['bookerId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(StarterResponseFromJSON));
    }

    /**
     */
    async apiStartersShowShowIdBookerBookerIdGet(requestParameters: ApiStartersShowShowIdBookerBookerIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<StarterResponse>> {
        const response = await this.apiStartersShowShowIdBookerBookerIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiStartersValidatePostRaw(requestParameters: ApiStartersValidatePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-KEY"] = await this.configuration.apiKey("X-API-KEY"); // ApiKey authentication
        }

        const response = await this.request({
            path: `/api/Starters/validate`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: StarterDtoToJSON(requestParameters['starterDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiStartersValidatePost(requestParameters: ApiStartersValidatePostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiStartersValidatePostRaw(requestParameters, initOverrides);
    }

}
